import { useEffect, useState } from 'react';
import { Box, Link, Typography } from '@mui/material';

import { Button, InfoDialog } from '@occc-app/design-system';
import { useS3Loader } from '@occc/feat-file-download';

import { messages } from '../../promocodes.messages';

type PromocodesIndividualDownloadDialogProps = {
  open: boolean;
  fileName: string;
  downloadUrl?: string | null;
  error?: string;
  loading: boolean;
  onClose: () => void;
};

export const PromocodesIndividualDownloadDialog = ({
  open,
  fileName,
  downloadUrl,
  error,
  loading,
  onClose,
}: PromocodesIndividualDownloadDialogProps) => {
  const [showDirectLinkFallback, setShowDirectLinkFallback] = useState(false);

  const { download, loading: isDownloading } = useS3Loader({
    filename: fileName,
    onError: () => setShowDirectLinkFallback(true),
  });

  useEffect(() => {
    if (!open) {
      setShowDirectLinkFallback(false);
    }
  }, [open]);

  const handleDownload = () => {
    if (downloadUrl) {
      download(downloadUrl);
    }
  };

  return (
    <InfoDialog
      dialogTitle='Download file'
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { width: 400 } }}
    >
      <Box sx={{ minHeight: 88 }}>
        {loading ? (
          <Typography variant='body2'>{messages.downloadLinkGenerating}</Typography>
        ) : error ? (
          <Typography variant='body2' color='error'>
            {error}
          </Typography>
        ) : downloadUrl ? (
          showDirectLinkFallback ? (
            <>
              <Typography variant='body2' paragraph>
                {messages.downloadAutomaticFailed}
              </Typography>
              <Link
                href={downloadUrl}
                download={fileName}
                target='_blank'
                rel='noopener noreferrer'
              >
                {fileName}
              </Link>
            </>
          ) : (
            <>
              <Typography variant='body2' paragraph>
                {messages.downloadReady}
              </Typography>
              <Button variant='contained' onClick={handleDownload} disabled={isDownloading}>
                {isDownloading ? messages.downloading : messages.downloadFile}
              </Button>
            </>
          )
        ) : null}
      </Box>
    </InfoDialog>
  );
};
